<nav class="navbar navbar-expand-sm navbar-dark" [ngClass]="environment">
  <a class="navbar-brand" [routerLink]="['', permissionService.hasInitialContents()]">
    <img src="../../../assets/images/allox_logo.gif" height="18" style="padding-right: 5.7rem">
  </a>
  <button type="button" class="navbar-toggler" data-toggle="collapse" data-target="#Navber" aria-controls="Navber"
    aria-expanded="false" aria-label="メニュー">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="navbar-collapse collapse" id="Navber">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item dropdown" role="button" *ngIf="permissionService.hasCreatePermission(constants.Contents.DELIVERY_SET);else deliverySetBlock">
        <a class="nav-link  dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" [class.active]="isDeliverySetActive()" >配信セット</a>
        <div class="dropdown-menu">
          <a class="dropdown-item" [routerLink]="['', 'delivery_sets']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            配信セット
          </a>
          <a class="dropdown-item" [routerLink]="['/delivery_sets/batch', 'new']" routerLinkActive="active">
            配信セット一括登録
          </a>
        </div>
      </li>
      <ng-template #deliverySetBlock>
        <li class="nav-item" role="button">
          <a class="nav-link" [routerLink]="['', 'delivery_sets']" routerLinkActive="active" *ngIf="permissionService.hasReadPermission(constants.Contents.DELIVERY_SET)">
            配信セット
          </a>
        </li>
      </ng-template>

      <li class="nav-item dropdown" role="button">
        <a class="nav-link  dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
          aria-expanded="false" [class.active]="isDesignTemplateActive()"
          *ngIf="isDesignTemplateDisplay()">デザインテンプレート</a>
        <div class="dropdown-menu">
          <a class="dropdown-item" [routerLink]="['', 'design_templates']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.DESIGN_TEMPLATE)">
            デザインテンプレート
          </a>
          <a class="dropdown-item" [routerLink]="['', 'standard_design_templates']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.STANDARD_DESIGN_TEMPLATE)">
            標準デザインテンプレート
          </a>
        </div>
      </li>

      <li class="nav-item dropdown" role="button" *ngIf="permissionService.hasCreatePermission(constants.Contents.PLACEMENT_RELATION);else placementRelationBlock">
        <a class="nav-link  dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"
          [class.active]="isPlacementRelationActive()" >プレースメント設定</a>
        <div class="dropdown-menu">
          <a class="dropdown-item" [routerLink]="['', 'placement_relations']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            プレースメント設定
          </a>
          <a class="dropdown-item" [routerLink]="['/placement_relations/batch', 'new']" routerLinkActive="active">
            プレースメント設定一括登録
          </a>
        </div>
      </li>
      <ng-template #placementRelationBlock>
        <li class="nav-item" role="button">
          <a class="nav-link" [routerLink]="['', 'placement_relations']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.PLACEMENT_RELATION)">
            プレースメント設定
          </a>
        </li>
      </ng-template>
      <li class="nav-item dropdown" role="button" *ngIf="permissionService.hasCreatePermission(constants.Contents.PLATFORM_RESERVATION);else platformReservationsBlock">
        <a class="nav-link  dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"
          [class.active]="isPlatformReservationActive()" >配信PF予約登録</a>
        <div class="dropdown-menu">
          <a class="dropdown-item" [routerLink]="['', 'platform_reservations']" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
            配信PF予約登録
          </a>
          <a class="dropdown-item" [routerLink]="['/platform_reservations/batch', 'new']" routerLinkActive="active">
            配信PF予約一括登録
          </a>
        </div>
      </li>
      <ng-template #platformReservationsBlock>
        <li class="nav-item" role="button">
          <a class="nav-link" [routerLink]="['', 'platform_reservations']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.PLATFORM_RESERVATION)">
            配信PF予約登録
          </a>
        </li>
      </ng-template>
      <li class="nav-item" role="button">
          <a class="nav-link" [routerLink]="['', 'ad_requests']" routerLinkActive="active"
             *ngIf="permissionService.hasReadPermission(constants.Contents.AD_REQUEST)">
              広告リクエスト設定
          </a>
      </li>
      <li class="nav-item" role="button">
        <a class="nav-link" [routerLink]="['', 'placements']" routerLinkActive="active"
          *ngIf="permissionService.hasReadPermission(constants.Contents.PLACEMENT)">
          タグ設定
        </a>
      </li>
      <li class="nav-item dropdown" role="button">
        <a class="nav-link  dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true"
          aria-expanded="false" [class.active]="isMasterManagerActive()" *ngIf="isMasterManagerDisplay()">マスタ管理</a>
        <div class="dropdown-menu">
          <a class="dropdown-item" [routerLink]="['', 'tester_devices']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.TESTER_DEVICE)">
            テスト端末
          </a>
          <a class="dropdown-item" [routerLink]="['', 'device_models']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.DEVICE_MODEL)">
            機種
          </a>
          <a class="dropdown-item" [routerLink]="['', 'device_model_groups']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.DEVICE_MODEL_GROUP)">
            機種グループ
          </a>
          <a class="dropdown-item" [routerLink]="['', 'operating_systems']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.OPERATING_SYSTEM)">
            OS
          </a>
          <a class="dropdown-item" [routerLink]="['', 'os_groups']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.OS_GROUP)">
            OSグループ
          </a>
          <a class="dropdown-item" [routerLink]="['', 'platform_os_groups']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.PLATFORM_OS_GROUP)">
            PF別OSグループ
          </a>
          <a class="dropdown-item" [routerLink]="['', 'sdk_versions']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.SDK_VERSION)">
            SDKバージョン
          </a>
          <a class="dropdown-item" [routerLink]="['', 'sdk_version_groups']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.SDK_VERSION_GROUP)">
            SDKバージョングループ
          </a>
          <a class="dropdown-item" [routerLink]="['', 'platform_sdk_version_groups']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.PLATFORM_SDK_VERSION_GROUP)">
            PF別SDKバージョングループ
          </a>
          <a class="dropdown-item" [routerLink]="['', 'deals']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.DEAL)">
            Deal
          </a>
          <a class="dropdown-item" [routerLink]="['', 'exchange_rates']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.EXCHANGE_RATE)">
            ドルレート
          </a>
          <a class="dropdown-item" [routerLink]="['', 'topics_urls']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.TOPICS_URL)">
            TopicsURL
          </a>
          <a class="dropdown-item" [routerLink]="['', 'ad_request_parameter_templates']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.AD_REQUEST_PARAMETER_TEMPLATE)">
            広告リクエストパラメータテンプレート
          </a>
          <a class="dropdown-item" [routerLink]="['', 'users']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.USERS)">
            ユーザ管理
          </a>
        </div>
      </li>
    </ul>

    <ul class="navbar-nav">
      <span class="navbar-text" *ngIf="environment !== 'prd'">
        <span class="rounded border border-warning text-warning py-1 px-2 mr-3" [ngSwitch]="environment">
          <span *ngSwitchCase="'local'">Local</span>
          <span *ngSwitchCase="'stg'">Staging</span>
          <span *ngSwitchCase="'feature'">Feature</span>
          <span *ngSwitchCase="'dev'">Develop</span>
        </span>
      </span>
      <li class="nav-item dropdown notification" role="button">
        <a class="nav-link dropdown-toggle" [class.active]="(notificationItems$ | async).length > 0" href="#"
          role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <fa-layers [fixedWidth]="false">
            <fa-icon icon="bell"></fa-icon>
            <fa-layers-counter *ngIf="(notificationItems$ | async).length > 0"
              [content]="(notificationItems$ | async).length" class="fa-icon-counter"></fa-layers-counter>
          </fa-layers>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <h6 class="dropdown-header">
            <fa-icon icon="bell"></fa-icon> お知らせ
          </h6>
          <a class="dropdown-item py-2" *ngIf="(notificationItems$ | async).length === 0">
            <div class="message text-muted">
              お知らせはありません。
            </div>
          </a>
          <a class="dropdown-item error" *ngFor="let item of (notificationItems$ | async)">
            <div class="message">
              <fa-icon [icon]="item.icon"></fa-icon>{{ item.message }}
            </div>
          </a>
        </div>
      </li>


      <li class="nav-item dropdown setting-item" role="button">
        <a class="nav-link dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false" [class.active]="isConfigurationActive()">
          <fa-icon icon="cog"></fa-icon> 設定
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a class="dropdown-item" [routerLink]="['', 'emergency_stop']" routerLinkActive="active"
            *ngIf="permissionService.hasReadPermission(constants.Contents.EMERGENCY_STOP)">
            緊急停止
          </a>
          <a class="dropdown-item" [routerLink]="['', 'platforms', 'keys']" routerLinkActive="active"
            *ngIf="permissionService.hasExecutePermission(constants.Contents.PLATFORMS_KEYS)">
            暗号化キー生成
          </a>
          <a class="dropdown-item" [routerLink]="['', 'maintenance']" routerLinkActive="active"
          *ngIf="permissionService.hasReadPermission(constants.Contents.MAINTENANCE)">
            メンテナンス管理
          </a>
          <a class="dropdown-item" href="javascript:void(0);" (click)="logout()"> ログアウト </a>
          <span class="dropdown-item" *ngIf="developerService.isDeveloper">
            <div class="text-muted small">Version:</div>
            {{ developerService.version }}
          </span>
        </div>
      </li>
    </ul>
  </div>
</nav>
